<template>
    <div>
         <modal :name="thoseModalName" class="relative pb-5" id="modal" :height="'auto'" :width="modal_width" >
            <div class="modal-header">
                <div class="absolute icon-close" @click="hideModal(thoseModalName)">
                    <img class="img-responsive" id="icon-close-modal" src="@/assets/home/icons/icon-close.png" alt="Icon-close">
                </div>
                <div class="flex j-c-center">
                    <div class="logo">
                        <img class="img-responsive" src="@/assets/logoBrancaHorizontal.png" alt="logoAzulHorizontal">
                    </div>
                </div>
            </div>
            <div class="modal-body c-center">
                <div class="container">
                    <div>
                        <p><strong>Faturamento mensal:</strong> {{monthlyInvoicingString}}.</p> <br>
                        <p>
                            Você <strong>perde</strong> mensalmente entre <strong>{{qtdeFaturamento8}} e {{qtdeFaturamento10}}</strong> de faturamento dos clientes que deixam de pagar as contas e boletos na sua lotérica (SITAE).
                        </p> <br>
                        <p><strong>Em 1 ano</strong> isso representa perdas entre <strong>{{qtdeFaturamento8Year}} e {{qtdeFaturamento10Year}}!</strong></p> <br>
                        <p><strong>Deixa de atender mensalmente</strong> entre <strong>{{lostCustomersMIN}} e {{lostCustomersMAX}}</strong> clientes atuais e novos.</p> <br>
                        <p>
                            <strong>Além de recuperar</strong> este faturamento perdido, saiba que <strong>com uma franquia da Ponto Fácil</strong> você <strong>faturaria adicionalmente  entre {{billingGainMIN}} e {{billingGainMAX}} mensais.</strong>                    
                        </p> <br>
                        <p>
                            No total você está <strong>deixando de ganhar</strong> entre 
                            <strong>{{stopWinningMIN}}</strong>
                            e <strong>{{stopWinningMAX}}</strong> por mês e isso representa <strong>{{stopWinningMIN_ANO}} e {{stopWinningMAX_ANO}}</strong> por ano! <br><br>   <strong>É muito dinheiro que você está perdendo!</strong>
                        </p> <br>
                        <p>
                            Clique abaixo e descubra a franquia que pode transformar os seus resultados!
                        </p>                
                    </div>
                     <a class="color-white w-100 text-center" href="//www.franquia.pontofacil.com.br/">
                        <div class="goResults mb-3">Transformar meus resultados</div>
                        </a>
                </div>
            </div>
        </modal>
    </div>
</template>

<style scoped>
    .icon-close{
        right: 40px;
        top: 5px!important;
        width: 0px!important;
    }

    .goResults:hover{
        color: #fff;
        opacity: .85;
    }

    .goResults{
        background-color: rgb(23, 93, 147);
        padding: 15px 50px;
        font-size: 14px;
        border-radius: 10px;
        font-weight: 700;
        text-transform: uppercase;
    }

    p{
        margin-bottom: 5px;
        line-height: 24px;
    }

    .logo img{
        width: 150px;
    }

    .icon-close img{
        width: 35px!important;
    }

    .icon-close:hover{
        cursor: pointer;
    }

    .modal-header{
        background-color: #357EB8;
        border: none;
    }

    .modal-header > div{
        width: 100%;
    }
    div >>> .v--modal-box.v--modal{
        border: 3px solid #fff;
        border-bottom: none;
        position: relative;
        /* overflow: visible; */
        overflow: auto;
    }

    div >>> #modal{
        overflow: auto;
    }
    .transformar-father{
        margin: 15px!important;
    }
    @media only screen and (max-width: 500px){
        .icon-close img{
            width: 25px!important;
        }
        .icon-close{
            right: 30px;
        }
    }

    @media only screen and (max-width: 430px){
        .modal-content{
            height: 56%!important;
        }
    }  
    
    @media only screen and (max-width: 375px){
        .modal-content{
            height: 53%!important;
        }
    }

/*Modal*/

</style>

<script>
export default {
    data(){
        return {
            modal_width:0,
        }
    },
    
    props:[
        'thoseModalName',
        'monthlyInvoicingString',
        'qtdeFaturamento8',
        'qtdeFaturamento8Year',
        'qtdeFaturamento10',
        'qtdeFaturamento10Year',
        'lostCustomersMIN',
        'lostCustomersMAX',
        'perdaAnoMin',
        'perdaAnoMax',
        'billingGainMIN',
        'billingGainMAX',
        'stopWinningMAX',
        'stopWinningMIN',
        'stopWinningMIN_ANO',
        'stopWinningMAX_ANO',
    ],
    
    created() {
        /* eslint-disable no-console */
        // console.log()
        /* eslint-enable no-console */
        let that = this
        if($(window).width()<=768){
            that.modal_width += '90%'
        }else{
            that.modal_width += '50%'
        }
    },
    mounted() {
        
    },
}

</script>